export default {
    name: 'CourseMixin',

    data() {
        return {};
    },

    computed: {
        access_starts_at() {
            return this.course.availability.starts_at;
        },

        access_ends_at() {
            return this.course.availability.ends_at;
        },

        course_available() {
            return this.course.availability.available;
        },

        gets_unlocked_in_future() {
            // check if this is guarded now, but the starts at is in the future
            const now = new Date();
            const starts_at = new Date(
                this.access_starts_at
            );

            if (!this.course_available && starts_at > now) {
                return true;
            }

            return false;
        },

        access_to_course_until() {
            const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

            if (
                this.course.availability.ends_at &&
                moment(this.course.availability.ends_at).format(
                    'YYYY-MM-DD HH:mm:ss'
                ) > today
            ) {
                const difference_days = moment(
                    this.course.availability.ends_at
                ).diff(today, 'days');
                if (difference_days === 0) {
                    return {
                        text: `${this.$t(
                            'membership.available_until'
                        )} ${moment(this.course.availability.ends_at).format(
                            'YYYY-MM-DD HH:mm:ss'
                        )}`,
                        below_seven_days_remaning: true,
                    };
                } else if (difference_days <= 7) {
                    return {
                        text: `${difference_days} ${
                            difference_days > 1
                                ? this.$t(
                                      'membership.days_remaining'
                                  ).toLowerCase()
                                : this.$t(
                                      'membership.day_remaining'
                                  ).toLowerCase()
                        }`,
                        below_seven_days_remaning: true,
                    };
                } else {
                    return {
                        text: `${this.$t(
                            'membership.access_until'
                        ).toLowerCase()} ${moment(
                            this.course.availability.ends_at
                        ).format('DD-MM-YYYY')}`,
                        below_seven_days_remaning: false,
                    };
                }
            }

            return false;
        },

        access_to_course_from() {
            const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

            if (
                this.course.availability.starts_at &&
                moment(this.course.availability.starts_at).format(
                    'YYYY-MM-DD HH:mm:ss'
                ) > today
            ) {
                return `${this.$t(
                    'membership.access_from'
                ).toUpperCase()} ${moment(
                    this.course.availability.starts_at
                ).format('DD-MM-YYYY HH:mm')}`;
            }

            return false;
        },
    },
};
